module.exports = __webpack_public_path__ + "img/youhui_icon.24d51980.png";